export const ROLES = [
  { role: "Investor", amount: 20 },
  { role: "Company", amount: 30 },
];
